<script>
    export let title = null
    export let subtitle = null
    export let closeable = true
    export let style = ''
    export let justifyButtons = 'flex-end'
    import { CloseCircle } from '../Icons'
    import { Typography } from '.'
    import { Svrollbar } from 'svrollbar'
    import { fly } from 'svelte/transition'
    import { createEventDispatcher } from 'svelte'
    import { clickOutside } from '$lib/utils'
    const dispatch = createEventDispatcher()
    function onClose() {
        dispatch('close')
    }
    function onClickOut() {
        dispatch('clickout')
    }
</script>

<div
    transition:fly={{ y: 50, duration: 500 }}
    use:clickOutside
    on:clickout={onClickOut}
    class="modal"
    {style}
>
    {#if closeable}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span class="close" on:click={onClose}>
            <CloseCircle color="#6E6F71" size={24} title="Cerrar ventana" />
        </span>
    {/if}
    <span class="header">
        {#if title}
            <Typography style="margin: 0" type="h4">{title}</Typography>
        {/if}
        {#if subtitle}
            <Typography style="margin: 0" type="body" color="grey-800"
                >{subtitle}</Typography
            >
        {/if}
    </span>
    {#if $$slots.default}
        <span class="content">
            <slot />
        </span>
    {/if}
    {#if $$slots.buttonSet}
        <span class="buttonSet">
            <slot
                name="buttonSet"
                style={`justify-content: ${justifyButtons}`}
            />
        </span>
    {/if}
</div>

<style>
    .modal {
        position: relative;
        display: grid;
        grid-template-rows: auto 1fr 50px;
        padding: 40px;
        gap: 8px;
        width: 618px;
        /* height: 342px; */
        max-height: 100%;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: var(--shadow-bottom-bar);
    }

    .modal span.close {
        cursor: pointer;
        position: absolute;
        top: 40px;
        right: 40px;
    }

    .modal span.content {
        position: relative;
        overflow-y: hidden;
    }

    .modal span.header {
        height: auto;
        display: flex;
        flex-direction: column;
        gap: 5px;
        justify-content: space-between;
    }

    .modal span.buttonSet {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: row;
        margin: 0;
        padding: 0;
        justify-content: flex-end;
        gap: 16px;
    }
</style>
